import React from "react";
import * as S from "./Review-popup.styles";
import Modal from "../../../../../../core-components/generic-modal-component/GenericModal";
import Button from "../../../../../stories/core-components/Button/ButtonUI";
import Icon from "../../../../../stories/core-components/IconsSelector";

interface IReviewpopup {
  t: string;
  st?: string;
  msg?: string;
  cta1: ICta;
  cta2?: ICta;
  updateInfo: Function;
}

interface ICta {
  text?: string;
  action?: string;
}

const ReviewPopup: React.FC<IReviewpopup> = ({
  t,
  st,
  msg,
  cta1 = {},
  cta2 = {},
  updateInfo = () => {},
}) => {
  if (!t && !msg && !Object.keys(cta1)?.length) {
    return null;
  }
  const closeModal = (action) => {
    updateInfo(action);
  };

  const modalStyles = Object.keys(cta2)?.length
    ? {
        height: Object.keys(cta1)?.length ? "35.9rem" : "25.9rem",
        width: "50.7rem",
      }
    : { height: "25.9rem", width: "50.7rem" };
  return (
    <>
      <Modal isOpen={true} onCloseModal={closeModal} modalStyles={modalStyles}>
        {false ? (
          <S.StyledModal>
            <S.StylingDiv>
              <Icon
                name="GreenTickIcon"
                styleProps={{ width: "7.5rem", height: "7.5rem" }}
              />
            </S.StylingDiv>
            {t ? (
              <S.StylingDiv>
                <S.HeaderTxt txtAlign={"center"}>{t}</S.HeaderTxt>
              </S.StylingDiv>
            ) : null}
            <S.StylingDiv>
              <S.HeaderTxt txtAlign={"center"}>{cta1.txt}</S.HeaderTxt>
            </S.StylingDiv>
            <S.StylingDiv onClick={() => closeModal(cta1.action)}>
              <Button name={cta} btnWidth={"46rem"} btnHeight={"4rem"} />
            </S.StylingDiv>
          </S.StyledModal>
        ) : (
          <>
            <S.StyledModalHeader>
              {t ? <S.SectionHeader>{t}</S.SectionHeader> : null}
              <S.StyledIcon onClick={() => closeModal(cta1.action)}>
                <Icon name="ClosePopupIcon" />
              </S.StyledIcon>
            </S.StyledModalHeader>
            {st ? (
              <S.Styling>
                <S.HeaderTxt>{st}</S.HeaderTxt>
              </S.Styling>
            ) : null}
            {msg ? (
              <S.Styling>
                <S.FooterTxt>{msg}</S.FooterTxt>
              </S.Styling>
            ) : null}
            {cta1?.text ? (
              <S.Styling onClick={() => closeModal(cta1.action)}>
                <div
                  style={
                    !cta2?.text ? { position: "fixed", bottom: "24px" } : {}
                  }
                >
                  <Button
                    name={cta1.text}
                    btnBgColor={"#fff"}
                    btnWidth={"46rem"}
                    btnHeight={"4rem"}
                    btnColor={"#ff6d38"}
                    btnBorder={"solid 1px #ff6d38"}
                  />
                </div>
              </S.Styling>
            ) : null}
            {cta2?.text ? (
              <S.Styling onClick={() => closeModal(cta2.action)}>
                <div
                  style={
                    !cta1?.text ? { position: "fixed", bottom: "24px" } : {}
                  }
                >
                  <Button
                    name={cta2.text}
                    btnWidth={"46rem"}
                    btnHeight={"4rem"}
                  />
                </div>
              </S.Styling>
            ) : null}
          </>
        )}
      </Modal>
    </>
  );
};

export default React.memo(ReviewPopup);

